import { object, string } from "zod";

export const getMultipassSecret = {
  name: "getMultipassSecret" as const,
  input: object({ teamId: string() }),
  output: object({ multipassSecret: string().optional() }),
};
